// extracted by mini-css-extract-plugin
export default {"action_failed":"ActionFailed_action_failed__Oj4KO","dark":"ActionFailed_dark__o78mV","action_failed_container":"ActionFailed_action_failed_container__FLDv0"};